const UserGuideTexts = {
    'choose-base-voice': "On this page, select a base voice for your new design. You can choose from our collection of voices, upload an existing audio file, or record your own speech. We only accept base audio under 30 seconds. If your uploaded or recorded audio exceeds 30 seconds, only the last 29 seconds will be used as the base voice."
};
export default UserGuideTexts;